import {
  type FetchAllowlistMemberships,
  fetchAllowlistMemberships,
  isUserAllowlisted,
} from "@app/auth";
import { FETCH_REQUIRED_DATA } from "@app/bootup";
import { hasOrganization, selectOrganizationsAsList } from "@app/organizations";
import { useSelector } from "@app/react";
import { selectIsUserOwner } from "@app/roles";
import { schema } from "@app/schema";
import { selectIsAuthWithSso } from "@app/token";
import { selectCurrentUser } from "@app/users";

export const useSsoRequiredBlock = () => {
  const loader = useSelector((s) =>
    schema.loaders.selectById(s, { id: FETCH_REQUIRED_DATA }),
  );
  const isAuthWithSso = useSelector(selectIsAuthWithSso);
  const user = useSelector(selectCurrentUser);
  const orgs = useSelector(selectOrganizationsAsList);
  const org =
    orgs.length === 1
      ? orgs[0]
      : (orgs.find((o) => o.id === user.selectedOrganizationId) ??
        schema.organizations.empty);

  const isOwner = useSelector((s) => selectIsUserOwner(s, { orgId: org.id }));
  // fetched as part of bootup's FETCH_REQUIRED_DATA sequence, so we only read
  // the cache here instead of triggering our own fetch.
  const allowlist = useSelector((s) =>
    schema.cache.selectById(s, {
      id: fetchAllowlistMemberships({ orgId: org.id }).payload.key,
    }),
  ) as FetchAllowlistMemberships | undefined;
  const isAllowlisted = isUserAllowlisted(
    allowlist?._embedded?.whitelist_memberships || [],
    user.id,
  );
  const blocked =
    loader.lastSuccess > 0 &&
    hasOrganization(org) &&
    org.ssoEnforced &&
    !isOwner &&
    !isAllowlisted &&
    !isAuthWithSso;

  return { blocked, org };
};
